import "./Util/httpAuth";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { responsiveFontSizes, ThemeProvider } from "@mui/material";
import reportWebVitals from "./reportWebVitals";
import { vm_theme } from "./Styles/VMStyles";
import { ToastContainer } from "react-toastify";
import NetworkOfflineDialog from "./Components/NetworkOfflineDialog";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import VMHome from "./DashBoard/Home/VMHome";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  ROUTE_ABOUT_US,
  ROUTE_ADD_ENQUIRY,
  ROUTE_ALL_ENQUIRIES,
  ROUTE_CONFIGURATION,
  ROUTE_CONTACT_US,
  ROUTE_CREATE_INVOICE,
  ROUTE_DELETE_ACCOUNT,
  ROUTE_ENQUIRY_DETAILS,
  ROUTE_FEEDBACK,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_HOME,
  ROUTE_HOW_TO_USE,
  ROUTE_TUTORIALS,
  ROUTE_INVOICE_HISTORY,
  ROUTE_LOGIN,
  ROUTE_PRIVACY_POLICY,
  ROUTE_PROFILE,
  ROUTE_RATE_US,
  ROUTE_REFUND_POLICY,
  ROUTE_REGISTRATION,
  ROUTE_REPORTS,
  ROUTE_ROLES,
  ROUTE_SUPER_ADMIN,
  ROUTE_SUPER_ADMIN_ENQUIRIES,
  ROUTE_SUPER_ADMIN_EVENTS,
  ROUTE_SUPER_ADMIN_VISITOR_LOGS,
  ROUTE_SUPER_ADMIN_EVENT_PHOTOS,
  ROUTE_ROOMS_ALLOCATE,
  ROUTE_SETTINGS,
  ROUTE_SUBSCRIPTION,
  ROUTE_TASKS,
  ROUTE_TEAM,
  ROUTE_TERMS_AND_CONDITIONS,
  ROUTE_UPDATE_TASK,
  ROUTE_UPDATE_CHECK_LIST,
  ROUTE_VISITOR_LOG,
  ROUTE_LANDING,
  ROUTE_MAIN_HOME,
  ROUTE_DASHBOARD,
  ROUTE_PRICING,
  ROUTE_CAREERS,
  ROUTE_VM_ABOUTUS,
  ROUTE_DEMO,
  ROUTE_APPOINTMENTSFollwUps,
  ROUTE_EVENTS,
  ROUTE_REGISTRATION_SUCCESS,
  ROUTE_ROOMS_REGISTRATION,
  ROUTE_VM_CONTACT_US,
  ROUTE_PRIVACY,
  ROUTE_TERMS_CONDITIONS
} from "./Util/VMConstants";
import Registration from "./LoginRegistration/Registration";
import ForgotPasword from "./LoginRegistration/ForgotPasword";
import PrivateRoute from "./Menu/PrivateRoute";
import VMProfile from "./DashBoard/Profile/VMProfile";
import VmInvoiceHistory from "./DashBoard/InvoiceHistory/VmInvoiceHistory";
import VMReports from "./DashBoard/Reports/VMReports";
import VMSettings from "./DashBoard/Settings/VMSettings";
import VMTeam from "./DashBoard/Team/VMTeam";
import VMRoles from "./DashBoard/Team/VMRoles";
import VMAboutUs from "./DashBoard/Settings/VMAboutUs";
import VMRateUs from "./DashBoard/Settings/VMRateUs";
import VMDeleteAccount from "./DashBoard/Settings/VMDeleteAccount";
import VMContactUs from "./DashBoard/Settings/VMContactUs";
import VMTermsAndConditions from "./DashBoard/Settings/VMTermsAndConditions";
import VMPrivacyPolicy from "./DashBoard/Settings/VMPrivacyPolicy";
import VMRefundPolicy from "./DashBoard/Settings/VMRefundPolicy";
import VMHowToUse from "./DashBoard/Settings/VMHowToUse";
import VMAddEnquiry from "./DashBoard/AddEnquiry/VMAddEnquiry";
import { Provider } from "react-redux";
import store from "./Redux/store";
import VMAllEnquiries from "./DashBoard/AllEnquiries/VMAllEnquiries";
import VMEnquiryDetails from "./DashBoard/EnquiryDetails/VMEnquiryDetails";
import Subscription from "./DashBoard/Subscription/Subscription";
import SubscriptionTier from "./DashBoard/Subscription/SubscriptionTier";
import VMMainForm from "./LoginRegistration/VMMainForm";
import VMCreateInvoice from "./DashBoard/EnquiryDetails/Invoice/VMCreateInvoice";
import VMConfiguration from "./DashBoard/Configurations/VMConfiguration";
import VMAllocateRooms from "./DashBoard/EnquiryDetails/VMAllocateRooms";
import PublicFeedbackForm from "./DashBoard/Feedback/PublicFeedbackForm";
import VMFeedback from "./DashBoard/Feedback/VMFeedback";
import VMVisitorLog from "./DashBoard/VisitorLog/VMVisitorLog";
import VMTaskChecklist from "./DashBoard/TaskChecklist/VMTaskCheckList";
import VMSuperAdmin from "./DashBoard/SuperAdmin/VMSuperAdmin";
import VMSuperAdminDashboard from "./DashBoard/SuperAdmin/VMSuperAdminDashboard";
import VMSuperAdminVenues from "./DashBoard/SuperAdmin/VMSuperAdminVenues";
import VMSuperAdminVenueTrack from "./DashBoard/SuperAdmin/VMSuperAdminVenueTrack";
import VMSuperAdminUsers from "./DashBoard/SuperAdmin/VMSuperAdminUsers";
import VMSuperAdminRecords from "./DashBoard/SuperAdmin/VMSuperAdminRecords";
import VMSuperAdminEventTypes from "./DashBoard/SuperAdmin/VMSuperAdminEventTypes";
import VMSuperAdminEvents from "./DashBoard/SuperAdmin/VMSuperAdminEvents";
import VMSuperAdminVisitorLogs from "./DashBoard/SuperAdmin/VMSuperAdminVisitorLogs";
import VMSuperAdminEventPhotos from "./DashBoard/SuperAdmin/VMSuperAdminEventPhotos";
import VMSuperAdminVendors from "./DashBoard/SuperAdmin/VMSuperAdminVendors";
import VMSuperAdminAddAdmin from "./DashBoard/SuperAdmin/VMSuperAdminAddAdmin";
import VMSuperAdminDeletedAccounts from "./DashBoard/SuperAdmin/VMSuperAdminDeletedAccounts";
import VMSuperAdminCountryMaster from "./DashBoard/SuperAdmin/VMSuperAdminCountryMaster";
import VMSuperAdminStateMaster from "./DashBoard/SuperAdmin/VMSuperAdminStateMaster";
import VMSuperAdminCityMaster from "./DashBoard/SuperAdmin/VMSuperAdminCityMaster";
import VMSuperAdminSubscriptions from "./DashBoard/SuperAdmin/VMSuperAdminSubscriptions";
import VMSuperAdminSubscriptionPlans from "./DashBoard/SuperAdmin/VMSuperAdminSubscriptionPlans";
import VMSuperAdminErrorLogs from "./DashBoard/SuperAdmin/VMSuperAdminErrorLogs";
import TaskUpdate from "./DashBoard/TaskChecklist/Tasks/TaskUpdate";
import CheckListUpdate from "./DashBoard/TaskChecklist/Checklist/CheckListUpdate";
import VMLandingPage from "./Main/Landing/VMLandingPage";
import VMMainHome from "./DashBoard/VMHome/VMMainHome";
import VMDashboard from "./DashBoard/Dashboard/VMDashBoard";
import PricingPage from "./Main/Pricing/VMPricing";
import CareersPage from "./Main/Career/Career";
import VMDemo from "./Main/Demo/VMDemo";
import VMENQAppointments from "./DashBoard/AppointmentsFollwups/VMENQAppointments";
import VMEnvents from "./DashBoard/AppointmentsFollwups/VMEnvents";
import VMRegistrationSuccess from "./LoginRegistration/Registration/VMRegistrationSuccess";
import VMRoomRegistrations from "./LoginRegistration/Registration/VMRoomRegistrations";
import VMLandingAboutUs from "./Main/AboutUs/VMLandingAboutUs";
import VMLandingContactUs from "./Main/ContactUs/VMLandingContactUs";
import VMLandPrivacy from "./Main/PrivacyPolicy/VMLandPrivacy";
import VMLandTerms from "./Main/Landing/TermsConditions/VMLandTerms";
import RoomAllocateAndPreview from "./DashBoard/EnquiryDetails/Options/RoomAllocateAndPreview";

// Suppress ResizeObserver warnings in development
if (process.env.NODE_ENV === "development") {
  const suppressedWarnings = ["ResizeObserver loop completed with undelivered notifications"];
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (suppressedWarnings.some((entry) => args[0]?.includes?.(entry))) {
      return;
    }
    originalConsoleError(...args);
  };
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("✅ Firebase service worker registered:", registration.scope);
    })
    .catch((err) => {
      console.error("❌ Firebase service worker registration failed:", err);
    });
}

// React Router setup
const root = ReactDOM.createRoot(document.getElementById("root"));

const appRouter = createBrowserRouter([
  {
    path: "/submitfeedback/:token", // public feedback form
    element: <PublicFeedbackForm />,
  },
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: (
          <PrivateRoute>
            <VMMainHome />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_MAIN_HOME,
        element: (
          <PrivateRoute>
            <VMMainHome />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_HOME,
        element: (
          <PrivateRoute>
            <VMHome />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_DASHBOARD,
        element: (
          <PrivateRoute>
            <VMDashboard />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_ALL_ENQUIRIES,
        element: (
          <PrivateRoute>
            <VMAllEnquiries />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_CREATE_INVOICE,
        element: (
          <PrivateRoute>
            <VMCreateInvoice />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_SUBSCRIPTION,
        element: (
          <PrivateRoute>
            <SubscriptionTier/>
            {/* <Subscription /> */}
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_PROFILE,
        element: (
          <PrivateRoute>
            <VMProfile />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_INVOICE_HISTORY,
        element: (
          <PrivateRoute>
            <VmInvoiceHistory />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_REPORTS,
        element: (
          <PrivateRoute>
            <VMReports />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_APPOINTMENTSFollwUps,
        element: (
          <PrivateRoute>
            <VMENQAppointments />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_EVENTS,
        element: (
          <PrivateRoute>
            <VMEnvents />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_ROLES,
        element: (
          <PrivateRoute adminOnly>
            <VMRoles />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_TASKS,
        element: (
          <PrivateRoute>
            <VMTaskChecklist />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_SUPER_ADMIN,
        element: (
          // <PrivateRoute>
            <VMSuperAdmin />
          // </PrivateRoute>
        ),
        /* Venue Manager Admin — use VMSuperAdmin* imports above; do not reference removed stubs (Home/Users/Enquiries/Tasks/Checklists/Feedback). */
        children: [
          { index: true, element: <VMSuperAdminDashboard /> },
          { path: "users", element: <VMSuperAdminUsers /> },
          { path: "venues", element: <VMSuperAdminVenues /> },
          { path: "venues/:venueId", element: <VMSuperAdminVenueTrack /> },
          { path: "enquiries", element: <VMSuperAdminRecords /> },
          { path: "records", element: <VMSuperAdminRecords /> },
          { path: "event-types", element: <VMSuperAdminEventTypes /> },
          { path: "events", element: <VMSuperAdminEvents /> },
          { path: "visitor-logs", element: <VMSuperAdminVisitorLogs /> },
          { path: "event-photos", element: <VMSuperAdminEventPhotos /> },
          { path: "vendors", element: <VMSuperAdminVendors /> },
          { path: "subscriptions", element: <VMSuperAdminSubscriptions /> },
          { path: "add-admin", element: <VMSuperAdminAddAdmin /> },
          { path: "deleted-accounts", element: <VMSuperAdminDeletedAccounts /> },
          { path: "settings/country-master", element: <VMSuperAdminCountryMaster /> },
          { path: "settings/state-master", element: <VMSuperAdminStateMaster /> },
          { path: "settings/city-master", element: <VMSuperAdminCityMaster /> },
          { path: "settings/subscription", element: <VMSuperAdminSubscriptionPlans /> },
          { path: "settings/error-logs", element: <VMSuperAdminErrorLogs /> },
        ],
      },
      {
        path: ROUTE_VISITOR_LOG,
        element: (
          <PrivateRoute>
            <VMVisitorLog />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_FEEDBACK,
        element: (
          <PrivateRoute>
            <VMFeedback />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_CONFIGURATION,
        element: (
          <PrivateRoute>
            <VMConfiguration />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_TEAM,
        element: (
          <PrivateRoute adminOnly>
            <VMTeam />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_SETTINGS,
        element: (
          <PrivateRoute>
            <VMSettings />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_ABOUT_US,
        element: (
          <PrivateRoute>
            <VMAboutUs />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_TERMS_AND_CONDITIONS,
        element: (
          <PrivateRoute>
            <VMTermsAndConditions />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_PRIVACY_POLICY,
        element: (
          <PrivateRoute>
            <VMPrivacyPolicy />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_REFUND_POLICY,
        element: (
          <PrivateRoute>
            <VMRefundPolicy />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_HOW_TO_USE,
        element: (
          <PrivateRoute>
            <VMHowToUse />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_TUTORIALS,
        element: (
          <PrivateRoute>
            <VMHowToUse />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_CONTACT_US,
        element: (
          <PrivateRoute>
            <VMContactUs />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_DELETE_ACCOUNT,
        element: (
          <PrivateRoute>
            <VMDeleteAccount />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_RATE_US,
        element: (
          <PrivateRoute>
            <VMRateUs />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_ADD_ENQUIRY,
        element: (
          <PrivateRoute>
            <VMAddEnquiry />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_ENQUIRY_DETAILS,
        element: (
          <PrivateRoute>
            <VMEnquiryDetails />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_ROOMS_ALLOCATE,
        element: (
          <PrivateRoute>
            <RoomAllocateAndPreview />
            {/* <VMAllocateRooms /> */}
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_UPDATE_TASK,
        element: (
          <PrivateRoute>
            <TaskUpdate />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTE_UPDATE_CHECK_LIST,
        element: (
          <PrivateRoute>
            <CheckListUpdate />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: ROUTE_LANDING,
    element: <VMLandingPage />,
  },
  {
    path: ROUTE_ROOMS_REGISTRATION,
    element: <VMRoomRegistrations />,
  },
  {
    path: ROUTE_REGISTRATION_SUCCESS,
    element: <VMRegistrationSuccess />,
  },
  {
    path: ROUTE_PRICING,
    element: <PricingPage />,
  },
  {
    path: ROUTE_VM_CONTACT_US,
    element: <VMLandingContactUs />,
  },
  {
    path: ROUTE_CAREERS,
    element: <CareersPage />,
  },
  {
    path: ROUTE_PRIVACY,
    element: <VMLandPrivacy />,
  },
  {
    path: ROUTE_TERMS_CONDITIONS,
    element: <VMLandTerms />,
  },
  {
    path: ROUTE_DEMO,
    element: <VMDemo />,
  },
  {
    path: ROUTE_VM_ABOUTUS,
    element: <VMLandingAboutUs />,
  },
  {
    path: ROUTE_LOGIN,
    element: <VMMainForm />,
  },
  {
    path: ROUTE_REGISTRATION,
    element: <Registration />,
  },
  {
    path: ROUTE_FORGOT_PASSWORD,
    element: <ForgotPasword />,
  },
]);

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Provider store={store}>
        <ThemeProvider theme={responsiveFontSizes(vm_theme)}>
          <ToastContainer />
          <NetworkOfflineDialog />
          <RouterProvider router={appRouter} />
        </ThemeProvider>
      </Provider>
    </LocalizationProvider>
  </React.StrictMode>
);

reportWebVitals();